document.addEventListener('DOMContentLoaded', function() {
    var accordions = document.querySelectorAll('.mfraccordion');

    // Add 'show' class to all collapse items by default to show them
    accordions.forEach(function(accordion) {
        var target = document.querySelector(accordion.dataset.target);
        target.classList.add('show');
        accordion.classList.remove('collapsed');
        accordion.querySelector('.icon').textContent = '-';
    });

    accordions.forEach(function(accordion) {
        accordion.addEventListener('click', function() {
            var target = document.querySelector(this.dataset.target);
            var icon = this.querySelector('.icon');
            
            if (target.classList.contains('show')) {
                target.classList.remove('show');
                this.classList.add('collapsed');
                icon.textContent = '+';
            } else {
                target.classList.add('show');
                this.classList.remove('collapsed');
                icon.textContent = '-';
            }
        });
    });
});
